


import {
    createStyles,
    makeStyles,
    Theme,
    Backdrop,
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    useMediaQuery,
    Button,
    Modal,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Close } from "@material-ui/icons";


import AutoCompleteAddres from "../AutoCompleteAddress/AutoCompleteAddres";
import { MapDraggableMarkerProps, MapDraggableMarker } from "modules/app/components/idha-components/google-map";
import { useCallback, useState } from "react";

export interface IGoogleMapsModal
    extends Omit<
        MapDraggableMarkerProps,
        "mapWidth" | "mapHeight" | "googleApiToken"
    > {
    handleClose?: () => void;
    open?: boolean;
}
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        modal: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            padding: theme.spacing(2, 4, 3),
            flexDirection: "column",
        },
        textFieldPlace: {
            marginBottom: theme.spacing(4),
        },
        modalTittle: {
            flex: 1,
        },
        footerButtons: {
            width: "100%",
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "flex-end",
        },
    })
);

const GoogleMapsModal: React.FC<IGoogleMapsModal> = ({
    handleClose,
    open,
    onChangeCoordinates,
    latitude,
    longitude,

    ...rest
}) => {
    const { t } = useTranslation(["common"]);

    const [currentCoord, setCurrentCoord] = useState({
        latitude: latitude,
        longitude: longitude,
    });

    const isMobileScreen = useMediaQuery("(max-width:650px)");
    const mapDimensions = {
        mapWidth: isMobileScreen ? "90vw" : "600px",
        mapHeight: isMobileScreen ? "60vh" : "60vh",
    };

    const handleOnChangeCoordinates = useCallback(
        (latitude: number, longitude: number) => {
            setCurrentCoord({ latitude, longitude });
        },
        []
    );

    const handleOnChooseCoordinates = useCallback(() => {
        onChangeCoordinates(currentCoord.latitude, currentCoord.longitude);
    }, [currentCoord]);
    const classes = useStyles();

    return <>
        
        <Modal
            open={open}
            onClose={handleClose}
            BackdropProps={{
                timeout: 500,
            }}
            BackdropComponent={Backdrop}
            className={classes.modal}
        >
            <div>
                <AppBar position="static">
                    <Toolbar variant={"regular"}>
                        <Typography
                            variant="body1"
                            className={classes.modalTittle}
                        >
                            SELECIONE UM LOCAL
                        </Typography>
                        <IconButton
                            edge="end"
                            color="inherit"
                            aria-label="menu"
                            onClick={handleClose}
                        >
                            <Close />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <div className={classes.paper}>
                    <AutoCompleteAddres
                        handleOnChangeCoordinates={handleOnChangeCoordinates}
                    />
                    <MapDraggableMarker
                        {...rest}
                        {...currentCoord}
                        googleApiToken="AIzaSyCKAuKukyqRbZPEQn2bJ4mR7j3rV9VlzCY"
                        mapHeight={mapDimensions.mapHeight}
                        mapWidth={mapDimensions.mapWidth}
                        onChangeCoordinates={handleOnChangeCoordinates}
                    />
                    <div className={classes.footerButtons}>
                        <Button onClick={handleClose}>{t("cancel")}</Button>
                        <Button
                            color="primary"
                            onClick={() => {
                                handleOnChooseCoordinates();
                                handleClose();
                            }}
                        >
                            {t("select")}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
        
    </>
};
export default GoogleMapsModal;
